// extracted by mini-css-extract-plugin
module.exports = {"title":"Contacts_title__TxY_M","link":"Contacts_link__tbj0A"};